/**
 *
 * @param {String} string
 * @returns {String}
 */
export const renderMarkdownLinks = (string) => {
  const pattern = /\[(?<href>[^\]]+)\]\((?<text>[^)]+)\)/g;
  return string.replace(
    pattern,
    '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>',
  );
};
